import * as React from 'react';
import notify from '../../shared/feedback/notifications';
import moment from 'moment';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import * as calendarAction from '../photographerCalendars/actions/CalendarActions';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import { handleError } from '../../shared/ErrorCatching';
import IWorkingAreaMap from '../workareas/IWorkingAreaMap';
import * as photographerActions from './PhotographerActions';
import PhotographerForm from './PhotographerForm';
import IPhotographerInput from './IPhotographerInput';
import { useTelemetryContext } from '../../telemetry/telemetryContext';
import { Logger } from '../../telemetry/loggers/Logger';
import { Firm } from './photographerForm/components/PhotographerFormComponentBlocked';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import { defaultWorkingHours } from '../photographerPersonalCalendar/defaultWorkingHours';

interface IProps {
    userId: number;
    user: any;
    products: any;
    showModal: boolean;
    availableLanguages: any;
    loggedInUser: any;
    calendar: any;
    workingHours: any;
    imageEditorFirms: any[];
    blockedForFirms: Firm[];
    agreements: any[];
    regions: any[];
    toggleModal: () => void;
    actions: IActions;
    logger: Logger;
    site: string;
}

interface IState {
    creating: boolean;
    user: any;
    products: any;
    calendar: any;
    errors: any;
    shouldUpdateMap: boolean;
    showAddScandphotosWorkingHoursConfirmation: boolean;
}

export class PhotographerModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            creating: false,
            user: {
                username: '',
                email: ''
            },
            products: {
                selected: [],
                items: []
            },
            calendar: {},
            errors: {},
            shouldUpdateMap: false,
            showAddScandphotosWorkingHoursConfirmation: false
        };

        this.create = this.create.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onCreated = this.onCreated.bind(this);
        this.onUpdated = this.onUpdated.bind(this);
        this.onDeleted = this.onDeleted.bind(this);
        this.onMapChange = this.onMapChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.createOrUpdate = this.createOrUpdate.bind(this);
        this.update = this.update.bind(this);
        this.productAdded = this.productAdded.bind(this);
        this.productRemoved = this.productRemoved.bind(this);
        this.onCalendarChange = this.onCalendarChange.bind(this);
        this.onToggleShouldUpdateMap = this.onToggleShouldUpdateMap.bind(this);
        this.onPointChange = this.onPointChange.bind(this);
        this.onPropertyChange = this.onPropertyChange.bind(this);
        this.onRangeChanged = this.onRangeChanged.bind(this);
        this.createCubiCasaConnection = this.createCubiCasaConnection.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (this.props.userId !== -1) {
            this.props.actions
                .getEditPhotographer(this.props.userId)
                .then(() => {
                    this.setState({
                        user: assign({}, this.props.user),
                        products: assign({}, this.props.products)
                    } as IState);
                })
                .catch((errorResponse: any) => {
                    if (errorResponse && errorResponse.errors) {
                        errorResponse.errors.forEach((e: any) => {
                            notify.failure(e.value);
                        });
                    }
                });
        } else {
            this.props.actions.loadNewViewModel().then(() => {
                this.setState({
                    products: assign({}, this.props.products)
                } as IState);
            });

            let businessHours: any = [0, 1, 2, 3, 4, 5, 6].map((day) => {
                return {
                    day: day,
                    isAvailable: !(day === 0 || day === 6),
                    start: moment('2000-01-01T08:00:00').toDate(),
                    end: moment('2000-01-01T17:00:00').toDate()
                };
            });
            let calendar = {
                items: [],
                se360WorkingHours: businessHours,
                scandphotosWorkingHours: []
            };
            this.setState({ calendar: calendar } as IState);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.calendar) {
            this.setState({
                calendar: assign({}, nextProps.calendar)
            } as IState);
        }

        /* When editing, set working hours on load */
        if (
            nextProps.workingHours &&
            (!this.state.calendar.se360WorkingHours || !this.state.calendar.scandphotosWorkingHours)
        ) {
            let calendar = this.state.calendar;
            calendar.se360WorkingHours = nextProps.workingHours.se360WorkingHours;
            calendar.scandphotosWorkingHours = nextProps.workingHours.scandphotosWorkingHours;
            this.setState({ calendar } as IState);
        }
    }

    render() {
        return (
            <div>
                <Modal bsSize="large" show={this.props.showModal} onHide={this.props.toggleModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.userId === -1
                                ? Translate('photographers/modal/title/create-new-photographer')
                                : Translate('photographers/modal/title/edit-photographer') +
                                  (this.props.user.name ? ': ' + this.props.user.name : '')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PhotographerForm
                            user={this.state.user}
                            updateCalendar={this.updateCalendar}
                            onChange={this.onChange}
                            onCreated={this.onCreated}
                            onUpdated={this.onUpdated}
                            onDeleted={this.onDeleted}
                            onRangeChanged={this.onRangeChanged}
                            onCheckboxChange={this.onCheckboxChange}
                            onMapChange={this.onMapChange}
                            onPointChange={this.onPointChange}
                            imageEditorFirms={this.props.imageEditorFirms}
                            blockedForFirms={this.props.blockedForFirms}
                            agreements={this.props.agreements}
                            regions={this.props.regions}
                            errors={this.state.errors}
                            products={this.state.products}
                            productAdded={this.productAdded}
                            productRemoved={this.productRemoved}
                            onCalendarChange={this.onCalendarChange}
                            isEditMode={this.props.userId !== -1}
                            shouldUpdateMap={this.state.shouldUpdateMap}
                            onToggleShouldUpdateMap={this.onToggleShouldUpdateMap}
                            availableLanguages={this.props.availableLanguages}
                            onPropertyChange={this.onPropertyChange}
                            calendar={this.state.calendar}
                            loggedInUser={this.props.loggedInUser}
                            createCubiCasaConnection={this.createCubiCasaConnection}
                            site={this.props.site}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.toggleModal}>
                            {Translate('photographers/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.createOrUpdate}
                        >
                            {this.state.creating
                                ? Translate('photographers/modal/footer/button-label/saving')
                                : Translate('photographers/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                {this.state.showAddScandphotosWorkingHoursConfirmation ? (
                    <ConfirmationModal
                        title={Translate(
                            'photographers/modal/form/bookable-scandphotos/add-working-hours/confirmation/title'
                        )}
                        text={Translate(
                            'photographers/modal/form/bookable-scandphotos/add-working-hours/confirmation/text'
                        )}
                        doButtonLabel={Translate(
                            'photographers/modal/form/bookable-scandphotos/add-working-hours/confirmation/confirm'
                        )}
                        doButtonStyle="primary"
                        cancelButtonLabel={Translate('cancel')}
                        do={this.makeBookableOnScandphotosWithDefaultWorkingHours}
                        closeModal={() => {
                            this.setState({
                                showAddScandphotosWorkingHoursConfirmation: false
                            } as IState);
                        }}
                    />
                ) : null}
            </div>
        );
    }

    productAdded(productId: number) {
        this.setState({
            products: {
                items: this.state.products.items,
                selected: [...this.state.products.selected, productId]
            }
        } as IState);
    }

    productRemoved(productId: number) {
        this.setState({
            products: {
                items: this.state.products.items,
                selected: this.state.products.selected.filter((id: number) => id !== productId)
            }
        } as IState);
    }

    createOrUpdate() {
        if (this.props.userId === -1) {
            this.checkForEmail();
            this.create();
        } else {
            this.update();
        }
    }

    checkForEmail() {
        let user = this.state.user;

        if (!user.email && user.username) {
            user.email = user.username;

            this.setState({ user: assign({}, user) } as IState);
        }
    }

    create() {
        this.setState({ creating: true } as IState);
        this.state.user.selectedProducts = this.state.products.selected;
        let user = assign({}, this.state.user);
        let calendar = assign({}, this.state.calendar);

        if (calendar.se360WorkingHours.length > 0) {
            calendar.se360WorkingHours.forEach((x) => {
                x.start = moment(moment(x.start).toDate()).format('HH:mm:ss');
                x.end = moment(moment(x.end).toDate()).format('HH:mm:ss');
            });
        } else {
            calendar.se360WorkingHours = [0, 1, 2, 3, 4, 5, 6].map((day) => {
                return {
                    day: day,
                    isAvailable: !(day === 0 || day === 6),
                    start: moment('2000-01-01T08:00:00').format('HH:mm:ss'),
                    end: moment('2000-01-01T17:00:00').format('HH:mm:ss')
                };
            });
        }

        calendar.scandphotosWorkingHours.forEach((x) => {
            x.start = moment(moment(x.start).toDate()).format('HH:mm:ss');
            x.end = moment(moment(x.end).toDate()).format('HH:mm:ss');
        });

        user.calendar = calendar;
        this.props.actions
            .addPhotographer(user)
            .then(() => {
                notify.success(Translate('create-photographer-success'));
                this.setState({ creating: false, user: {} } as IState);
                this.props.toggleModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        creating: false
                    } as IState);
                })
            );
    }

    update() {
        this.setState({ creating: true } as IState);
        this.state.user.selectedProducts = this.state.products.selected;
        let user = assign({}, this.state.user);
        let calendar = assign({}, this.state.calendar);

        if (calendar.se360WorkingHours) {
            calendar.se360WorkingHours.forEach((x) => {
                x.start = moment(moment(x.start).toDate()).format('HH:mm:ss');
                x.end = moment(moment(x.end).toDate()).format('HH:mm:ss');
            });
        } else {
            calendar.se360WorkingHours = [];
        }

        if (calendar.scandphotosWorkingHours) {
            calendar.scandphotosWorkingHours.forEach((x) => {
                x.start = moment(moment(x.start).toDate()).format('HH:mm:ss');
                x.end = moment(moment(x.end).toDate()).format('HH:mm:ss');
            });
        } else {
            calendar.scandphotosWorkingHours = [];
        }

        user.calendar = calendar;
        this.props.actions
            .updatePhotographer(this.props.userId, user)
            .then(() => {
                notify.success(Translate('photographer/modal/update/success'));
                this.setState({ creating: false, user: {} } as IState);
                this.props.toggleModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        creating: false
                    } as IState);
                })
            );
    }

    updateCalendar = () => {
        if (this.props.userId === -1) {
            this.makeNotBookableOnScandphotosWithoutWorkingHours();
            return;
        }

        let se360WorkingHours = [];
        let scandphotosWorkingHours = [];
        this.state.calendar.se360WorkingHours.forEach((x) => {
            se360WorkingHours.push({
                id: x.id,
                isAvailable: x.isAvailable,
                isAvailableForDusk: x.isAvailableForDusk,
                day: x.day,
                start: moment(moment(x.start).toDate()).format('HH:mm:ss'),
                end: moment(moment(x.end).toDate()).format('HH:mm:ss')
            });
        });

        this.state.calendar.scandphotosWorkingHours.forEach((x) => {
            scandphotosWorkingHours.push({
                id: x.id,
                isAvailable: x.isAvailable,
                isAvailableForDusk: x.isAvailableForDusk,
                day: x.day,
                start: moment(moment(x.start).toDate()).format('HH:mm:ss'),
                end: moment(moment(x.end).toDate()).format('HH:mm:ss')
            });
        });

        this.props.actions
            .updatePhotographerWorkingHours(
                this.state.calendar.photographerId,
                se360WorkingHours,
                scandphotosWorkingHours
            )
            .then(() => {
                this.makeNotBookableOnScandphotosWithoutWorkingHours();
                notify.success(
                    Translate('calendars/photographer-working-hours/update/toastr/success')
                );
            })
            .catch(() => {
                notify.failure(Translate('photographers/calendar/toastr/error'));
            });
    };

    onChange(e: any) {
        this.onPropertyChange(e.target.name, e.target.value);
    }

    onDeleted(event: any) {
        event.photographerId = this.state.user.id;
        this.props.actions.deletePhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onUpdated(event: any) {
        event.photographerId = this.state.user.id;
        this.props.actions.updatePhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onCreated(event: any) {
        event.photographerId = this.state.user.id;
        this.props.actions.createPhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onPropertyChange(property: string, value: any) {
        let user = this.state.user;
        user[property] = value;
        this.setState({ user: assign({}, user) } as IState);
    }

    onPointChange(value: any) {
        let user = this.state.user;
        user.addressPointLocation = value;
        this.setState({ user: assign({}, user) } as IState);
    }

    onMapChange(maps: IWorkingAreaMap[], userSite: number) {
        let user = this.state.user;

        if (userSite === 1 /* SE360 */) {
            user.se360WorkingAreaMaps = maps;
        } else if (userSite === 2 /* Scandphotos */) {
            user.scandphotosWorkingAreaMaps = maps;
        }

        this.setState({ user: assign({}, user) } as IState);
    }

    makeNotBookableOnScandphotosWithoutWorkingHours() {
        if (this.state.calendar.scandphotosWorkingHours.length === 0) {
            this.onPropertyChange('isBookableScandphotos', false);
        }
    }

    makeBookableOnScandphotosWithDefaultWorkingHours = () => {
        let calendar = assign({}, this.state.calendar);
        calendar.scandphotosWorkingHours = defaultWorkingHours();
        this.setState({ calendar } as IState);
        this.onPropertyChange('isBookableScandphotos', true);
    };

    onCheckboxChange(e: any) {
        if (
            e.target.name === 'isBookableScandphotos' &&
            e.target.checked &&
            this.state.calendar.scandphotosWorkingHours.length === 0
        ) {
            this.setState({ showAddScandphotosWorkingHoursConfirmation: true } as IState);
            return;
        }

        let user = this.state.user;
        user[e.target.name] = e.target.checked;
        this.setState({ user: assign({}, user) } as IState);
    }

    onCalendarChange(calendar: any) {
        calendar.items = calendar.items.map((item: any) => {
            return {
                id: item.id,
                photographerId: item.photographerId,
                orderId: item.orderId,
                title: item.title,
                description: item.description,
                type: item.type,
                start: moment(item.start).format(),
                end: moment(item.end).format(),
                editable: item.editable,
                site: item.site
            };
        });

        this.setState({ calendar: assign({}, calendar) } as IState);
    }

    onToggleShouldUpdateMap(value: boolean) {
        this.setState({ shouldUpdateMap: value } as IState);
    }

    onRangeChanged(from: any, to: any) {
        if (this.props.userId) {
            return this.props.actions.getPhotographerCalendar(this.props.userId, from, to);
        }
    }

    createCubiCasaConnection(id: number) {
        this.props.actions
            .createCubiCasaConnection(id)
            .then(() => {
                this.setState({ user: assign({}, this.props.user) });
            })
            .catch((error: any) => {
                const { logger, user } = this.props;

                const additionalInfo = {
                    userInfo: user
                        ? {
                              company: user.company,
                              cubiCasaId: user.cubiCasaId,
                              username: user.username
                          }
                        : null
                };
                logger.logException(error, additionalInfo);
                handleError(error, (errors: any): void => {
                    this.setState({
                        errors: errors,
                        creating: false
                    } as IState);
                });
            });
    }
}

function PhotographerModalWithLogger(props) {
    const { logger } = useTelemetryContext();

    return <PhotographerModal {...props} logger={logger} />;
}

function mapStateToProps(state: any) {
    return {
        imageEditorFirms: state.photographers.modal.imageEditorFirms.map((i: any) => {
            return { value: i.id, label: i.name };
        }),
        blockedForFirms: state.photographers.modal.blockedForFirms.map(
            (firm: { brokerFirmId: number; name: string }) => {
                return { id: firm.brokerFirmId, name: firm.name };
            }
        ),
        agreements: state.photographers.modal.agreements.map((a: any) => {
            return { value: a.id, label: a.name };
        }),
        regions: state.photographers.modal.regions.map((r: any) => {
            return { value: r.id, label: r.name };
        }),
        user: state.photographers.edit.photographer,
        products: state.photographers.modal.products,
        availableLanguages: state.photographers.modal.availableLanguages,
        calendar: state.photographers.calendar,
        workingHours: state.photographers.modal.workingHours,
        loggedInUser: state.user,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            addPhotographer: (photographer: IPhotographerInput) =>
                dispatch(photographerActions.addPhotographer(photographer)),
            loadNewViewModel: () => dispatch(photographerActions.newPhotographer()),
            getEditPhotographer: (userId: number) =>
                dispatch(photographerActions.getEditPhotographer(userId)),
            getPhotographerCalendar: (userId: number, from: any, to: any) =>
                dispatch(photographerActions.getPhotographerCalendar(userId, from, to)),
            updatePhotographer: (userId: number, user: IPhotographerInput) =>
                dispatch(photographerActions.updatePhotographer(userId, user)),
            createPhotographerCalendarItem: (item: any) =>
                dispatch(calendarAction.createPhotographerCalendarItem(item)),
            deletePhotographerCalendarItem: (item: any) =>
                dispatch(calendarAction.deletePhotographerCalendarItem(item)),
            updatePhotographerCalendarItem: (item: any) =>
                dispatch(calendarAction.updatePhotographerCalendarItem(item)),
            createCubiCasaConnection: (userId: number) =>
                dispatch(photographerActions.createCubiCasaConnection(userId)),
            updatePhotographerWorkingHours: (
                photographerId: number,
                se360WorkingHours: any,
                scandphotosWorkingHours: any
            ) =>
                dispatch(
                    photographerActions.updatePhotographerWorkingHours(
                        photographerId,
                        se360WorkingHours,
                        scandphotosWorkingHours
                    )
                )
        }
    };
}

interface IActions {
    addPhotographer: (photographer: IPhotographerInput) => any;
    loadNewViewModel: () => any;
    getEditPhotographer: (userId: number) => any;
    getPhotographerCalendar: (userId: number, from: any, to: any) => any;
    updatePhotographer: (userId: number, user: IPhotographerInput) => any;
    createPhotographerCalendarItem: (item: any) => any;
    deletePhotographerCalendarItem: (item: any) => any;
    updatePhotographerCalendarItem: (item: any) => any;
    createCubiCasaConnection: (userId: number) => any;
    updatePhotographerWorkingHours: (
        photographerId: number,
        se360WorkingHours: any[],
        scandphotosWorkingHours: any[]
    ) => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotographerModalWithLogger);
